import moment    from 'moment';
import BigNumber from 'bignumber.js';
import Model     from 'alto-orm/lib/orm/model';

class Transaction extends Model {
  // attrs: clientID (fkey), billHeaderID (fkey, optional), kind (string), amount (decimal),
  // balance (decimal), transactedAt (moment), description (string), displayDescription (string)

  static nominativeName = 'transakce';
  static accusativeName = 'transakci';

  static attrNameMapping = {
    clientID:     'client',
    billHeaderID: 'bill_header'
  };

  static humanKinds = { POI: 'body', KC: 'peníze', UTR: 'peníze' };

  static deserialize(row) {
    const transaction = super.deserialize(row);

    transaction.amount       = new BigNumber(row.amount);
    transaction.balance      = new BigNumber(row.balance);
    transaction.transactedAt = moment(row.transacted_at);

    return transaction;
  }

  static serialize(transaction) {
    const row = super.serialize(transaction);

    row.amount  = transaction.amount.toString();
    row.balance = transaction.balance.toString();

    if (transaction.transactedAt) { row.transacted_at = transaction.transactedAt.format(); }

    return row;
  }

  get humanKind() { return this.constructor.humanKinds[this.kind]; };
}

export default Transaction;
